import { useContext, useState } from "react";
import { Alert, Button, Form, Modal, Tooltip } from "antd";
import { PosturalExamination } from "./interfaces";
import {
  ALMSG_INTERNAL_ERR,
  DEL_SUCCESS,
  HOME_PATH,
  PATIENTS_PATH,
} from "../env";
import { deletePosturalExaminationData } from "./utils";
import { SignedInDoctor } from "../auth/interfaces";
import { SignedInContext } from "../AppEnv";
import { useNavigate } from "react-router-dom";
import { Patient } from "../patients/interfaces";

const DeleteExamModal = ({
  patient,
  posturalExamination,
  visible,
  setVisible,
  setExamDelSuccess,
}: {
  patient: Patient;
  posturalExamination?: PosturalExamination;
  visible: boolean;
  setVisible: Function;
  setExamDelSuccess: Function;
}) => {
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [errMsg, setErrMsg] = useState("");

  const [form] = Form.useForm();

  //submit data
  const onFinish = () => {
    if (posturalExamination != undefined)
      deletePosturalExaminationData(
        signedInDoctor,
        patient.id || -1,
        posturalExamination.examId
      )
        .then((exam: PosturalExamination) => {
          try {
            if (
              exam.examId == posturalExamination.examId &&
              exam.patientId == patient.id
            ) {
              setExamDelSuccess(true);
              setVisible(false);
            } else setErrMsg(ALMSG_INTERNAL_ERR);
          } catch (err: any) {
            setErrMsg(ALMSG_INTERNAL_ERR);
          }
        })
        .catch((err: any) => setErrMsg(ALMSG_INTERNAL_ERR));
  };

  return (
    <Modal
      title="Elimina dati esame"
      centered
      open={visible}
      footer={false}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={480}
    >
      {posturalExamination != undefined && (
        <Form
          form={form}
          name="control-hooks"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item>
            Sei sicuro di voler eliminare i dati relativi all'esame
            {" " + posturalExamination.type} svolto da {patient.name}{" "}
            {patient.surname} in data
            {posturalExamination.date != undefined
              ? " " + new Date(posturalExamination.date).toLocaleDateString()
              : ""}
            ?
          </Form.Item>

          {errMsg && (
            <Form.Item>
              <Alert
                message={ALMSG_INTERNAL_ERR}
                description="Cancellazione non riuscita"
                type="error"
                showIcon
              />
            </Form.Item>
          )}
          <Form.Item style={{ margin: "auto", textAlign: "right" }}>
            <Tooltip
              placement="top"
              title={
                "Attento!! Operazione irreversibile: perderai tutti i dati relativi all'esame"
              }
            >
              <Button
                type="dashed"
                htmlType="submit"
                style={{
                  background: "black",
                  color: "white",
                  margin: "2px",
                }}
              >
                CONFERMA
              </Button>
            </Tooltip>
            <Button type="primary" onClick={() => setVisible(false)}>
              ANNULLA
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default DeleteExamModal;
